export default __webpack_public_path__ + "static/media/LandingBanner.ffb7a3cc.png";